"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentHistory = exports.PaymentHistoryKeyBlock = exports.OneMonthPaymentHistory = exports.getPaymentHistoryData = void 0;
const react_1 = __importDefault(require("react"));
const base_react_components_1 = require("@navinc/base-react-components");
const styles_1 = require("./styles");
const paymentHistoryKey = {
    C: { title: 'Current', CircleContent: react_1.default.createElement(base_react_components_1.Icon, { name: "actions/check-circle" }), backgroundColor: base_react_components_1.theme.good },
    N: {
        title: 'Current with Zero Balance',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "CB"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '0': {
        title: 'Current with Zero Balance',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "CB"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '1': {
        title: '30 Days Late',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "30"),
        backgroundColor: base_react_components_1.theme.fair,
    },
    '2': { title: '60 Days Late', CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "60"), backgroundColor: base_react_components_1.theme.fair },
    '3': { title: '90 Days Late', CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "90"), backgroundColor: base_react_components_1.theme.poor },
    '4': {
        title: '120 Days Late',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "120"),
        backgroundColor: base_react_components_1.theme.poor,
    },
    '5': {
        title: '150 Days Late',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "150"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '6': {
        title: '180 Days Late',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "180"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '7': {
        title: 'Chapter 13 Bankruptcy',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "BA"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '8': {
        title: 'Foreclosure Proceeding',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "FA"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    '9': {
        title: 'Chapter 7, 11, or 12 Bankruptcy',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "BA"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    G: {
        title: 'Collection H Foreclosure',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "FA"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    J: {
        title: 'Voluntary Surrender Reposession',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "RF"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    L: {
        title: 'Charge-off',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "CO"),
        backgroundColor: base_react_components_1.theme.neutral500,
    },
    B: { title: 'Account Changed', CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "AC"), backgroundColor: base_react_components_1.theme.neutral500 },
    '-': { title: 'No Data Reported', CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "ND"), backgroundColor: base_react_components_1.theme.neutral500 },
    '': { title: 'Unknown', CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "UK"), backgroundColor: base_react_components_1.theme.neutral400 },
};
const getPaymentHistoryData = (status) => {
    var _a;
    return (_a = paymentHistoryKey[status]) !== null && _a !== void 0 ? _a : {
        title: 'Unknown',
        CircleContent: react_1.default.createElement(styles_1.TextCircle, null, "UK"),
        backgroundColor: base_react_components_1.theme.neutral500,
        color: base_react_components_1.theme.white,
    };
};
exports.getPaymentHistoryData = getPaymentHistoryData;
const OneMonthPaymentHistory = ({ month, status, }) => {
    const { title, color, backgroundColor, CircleContent } = (0, exports.getPaymentHistoryData)(status);
    return (react_1.default.createElement(styles_1.MonthBlock, { "$month": month },
        react_1.default.createElement(base_react_components_1.Copy, null, month),
        react_1.default.createElement(styles_1.Circle, { "$color": color, "$backgroundColor": backgroundColor, "aria-label": title }, CircleContent)));
};
exports.OneMonthPaymentHistory = OneMonthPaymentHistory;
const defaultBalanceDate = new Date(new Date().getFullYear(), new Date().getMonth() - 25, 1);
const generateCalendar = ({ balanceDate, paymentHistory = '', }) => {
    var _a;
    const calendar = {};
    const paymentHistoryArr = (_a = paymentHistory === null || paymentHistory === void 0 ? void 0 : paymentHistory.split('')) !== null && _a !== void 0 ? _a : [];
    const firstMonth = new Date(balanceDate !== null && balanceDate !== void 0 ? balanceDate : defaultBalanceDate);
    paymentHistoryArr.forEach((status, index) => {
        const currDate = new Date(firstMonth.getFullYear(), firstMonth.getMonth() - index, 1);
        const month = currDate.toString().split(' ')[1];
        const year = currDate.getFullYear();
        calendar[year] = Object.assign(Object.assign({}, calendar[year]), { [month]: status });
    });
    return calendar;
};
/**
 * Payment History Key - Info only
 * @returns
 */
const PaymentHistoryKeyBlock = () => (react_1.default.createElement(styles_1.KeyBlock, null, Object.entries(paymentHistoryKey).map(([key, value], idx) => {
    const { title, color, backgroundColor, CircleContent } = value;
    return (react_1.default.createElement(styles_1.KeySection, { key: `${key} ${idx}` },
        react_1.default.createElement(styles_1.Circle, { "$color": color, "$backgroundColor": backgroundColor }, CircleContent),
        ' ',
        react_1.default.createElement(base_react_components_1.Copy, null, title)));
})));
exports.PaymentHistoryKeyBlock = PaymentHistoryKeyBlock;
/**
 * Consumer's Payment History during the past 25 months beginning with the month represented by the balance date. The codes reflect the status of the account for each month and are displayed for balance reporting subscribers only.
 * @param props
 * @returns
 */
const PaymentHistory = ({ balanceDate, paymentHistory = '', }) => {
    var _a;
    const calendar = generateCalendar({ balanceDate, paymentHistory });
    const yearsDescending = (_a = Object.keys(calendar).reverse()) !== null && _a !== void 0 ? _a : [];
    return (react_1.default.createElement(react_1.default.Fragment, null, yearsDescending === null || yearsDescending === void 0 ? void 0 : yearsDescending.map((year) => {
        var _a, _b;
        return (react_1.default.createElement(styles_1.YearBlock, { key: year },
            react_1.default.createElement(base_react_components_1.Header, null, year),
            react_1.default.createElement(styles_1.MonthsBlock, null, (_b = (_a = Object.keys(calendar === null || calendar === void 0 ? void 0 : calendar[year])) === null || _a === void 0 ? void 0 : _a.reverse()) === null || _b === void 0 ? void 0 : _b.map((month) => {
                var _a;
                return (react_1.default.createElement(exports.OneMonthPaymentHistory, { month: month, status: (_a = calendar === null || calendar === void 0 ? void 0 : calendar[year]) === null || _a === void 0 ? void 0 : _a[month], key: `${year}/${month}` }));
            }))));
    })));
};
exports.PaymentHistory = PaymentHistory;
exports.default = exports.PaymentHistory;
//# sourceMappingURL=index.js.map